var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.breadcrumbs.length)?_c('div',{staticClass:"breadcrumbs"},[_c('ul',{staticClass:"breadcrumbs__list"},_vm._l((_vm.breadcrumbs),function(ref,index){
var path = ref.path;
var title = ref.title;
return _c('li',{key:index,staticClass:"breadcrumbs__item",class:{ active: index === _vm.breadcrumbs.length - 1 }},[(index === _vm.breadcrumbs.length - 1)?[_vm._v(_vm._s(title))]:_c('nuxt-link',{attrs:{"to":path}},[_vm._v(_vm._s(title))])],2)}),0)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }